export const CANONICAL_UUID_V4_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

export const normalizeCanonicalUuidV4 = (value) => {
    if (typeof value !== 'string') {
        return null;
    }
    const normalized = value.trim().toLowerCase();
    return CANONICAL_UUID_V4_PATTERN.test(normalized) ? normalized : null;
};

export const isCanonicalUuidV4 = (value) => normalizeCanonicalUuidV4(value) !== null;
